

const clusters_colors = {
  "Aging population regions": "#e74d6a",
  "Agriculture-based regions": "#959595",
  "Diversified metros": "#3e98b2",
  "Diversified non-metros": "#b2c0fd",
  "Educated and emigrating areas": "#fd9e86",
  "High tech manufacturing centers": "#ade6ef",
  "Industrial bases": "#d8a1c1",
  "Megacities": "#0a1c2a",
  "Public sector-led regions": "#dbdbdb",
  "Service-based economies": "#1641e5",
  "Superstar hubs": "#00a8fa",
  "Tourism havens": "#b2c0fd",
  "Trailing opportunity regions": "#ebebeb",
  "": "rgba(255,255,255,0)"
};

const choropleth_blue = [
  '#71d2f1',
  '#69c4e3',
  '#60b7d5',
  '#58aac7',
  '#509db9',
  '#4890ac',
  '#40849e',
  '#397791',
  '#316b84',
  '#295f78',
  '#22546b',
  '#1b485f',
  '#133d53',
  '#0c3247',
  '#05283c',
  '#001e31'
];

const choropleth_red = [
  '#fcedef',
  '#fcdde0',
  '#fbcdd0',
  '#fabcc1',
  '#f8acb2',
  '#f59ca4',
  '#f28b95',
  '#ee7987',
  '#ea6779',
  '#e5546c'
];

const job_growth_colors = {
  '<=-15': choropleth_blue[0],
  '-15 to -10': choropleth_blue[2],
  '-10 to -5': choropleth_blue[4],
  '-5 to 0': choropleth_blue[5],
  '0 to 5': choropleth_blue[6],
  '5 to 10': choropleth_blue[8],
  '>=10': choropleth_blue[9]
}

const job_growth_short_colors = colorMapToArray({
  '<-20%': choropleth_blue[0],
  '-20 to -10%': choropleth_blue[2],
  '-10 to 0%': choropleth_blue[5],
  '0 to 10%': choropleth_blue[7],
  '>10%': choropleth_blue[9]
});

const employment_rate_colors = {
  '<=50': choropleth_blue[0],
  '50 to 55': choropleth_blue[1],
  '55 to 60': choropleth_blue[2],
  '60 to 65': choropleth_blue[4],
  '65 to 70': choropleth_blue[5],
  '70 to 75': choropleth_blue[6],
  '75 to 80': choropleth_blue[7],
  '80 to 85': choropleth_blue[8],
  '>=85': choropleth_blue[9]
};

const employment_rate_short_colors = colorMapToArray({
  '<50%': choropleth_blue[0],
  '50 to 60%': choropleth_blue[1],
  '60 to 70%': choropleth_blue[4],
  '70 to 80%': choropleth_blue[6],
  '80 to 90%': choropleth_blue[8],
  '>=90%': choropleth_blue[9]
});

const occupational_change_colors = {
  '<=-50': choropleth_red[7],
  '-50 to -25': choropleth_red[6],
  '-25 to -20': choropleth_red[5],
  '-20 to -15': choropleth_red[4],
  '-15 to -10': choropleth_red[3],
  '-10 to -5': choropleth_red[2],
  '-5 to 0': choropleth_red[1],
  '0 to 2.5': choropleth_blue[2],
  '2.5 to 5': choropleth_blue[3],
  '5 to 7.5': choropleth_blue[4],
  '7.5 to 10': choropleth_blue[5],
  '10 to 15': choropleth_blue[6],
  '15 to 20': choropleth_blue[7],
  '20 to 25': choropleth_blue[8],
  '25 to 50': choropleth_blue[9],
  '>=50': choropleth_blue[10]
}

const occupational_change_short_colors = colorMapToArray({
  '<=-50': choropleth_red[7],
  '-50 to -10': choropleth_red[4],
  '-10 to 0': choropleth_red[2],
  '0 to 10': choropleth_blue[3],
  '10 to 50': choropleth_blue[7],
  '>=50': choropleth_blue[10]
});

const occupational_relative_colors = {
  '<=0.25': choropleth_blue[0],
  '0.25 to 0.5': choropleth_blue[1],
  '0.5 to 0.75': choropleth_blue[2],
  '0.75 to 1': choropleth_blue[3],
  '1 to 1.5': choropleth_blue[4],
  '1.5 to 2': choropleth_blue[5],
  '3 to 4': choropleth_blue[6],
  '4 to 5': choropleth_blue[7],
  '2 to 3': choropleth_blue[8],
  '5 to 7.5': choropleth_blue[9],
  '7.5 to 10': choropleth_blue[10],
  '10 to 12.5': choropleth_blue[11],
  '12.5 to 15': choropleth_blue[12],
  '15 to 17.5': choropleth_blue[13],
  '17.5 to 20': choropleth_blue[14],
  '>=20': choropleth_blue[15]
};

const occupational_relative_short_colors = colorMapToArray({
  '<=0.25': choropleth_blue[0],
  '0.25 to 0.5': choropleth_blue[2],
  '0.5 to 1': choropleth_blue[5],
  '1 to 5': choropleth_blue[7],
  '5 to 10': choropleth_blue[9],
  '10 to 20': choropleth_blue[12],
  '>=20': choropleth_blue[15]
});

const occupational_absolute_colors = {
  '<=0.5': choropleth_blue[0],
  '0.5 to 1': choropleth_blue[1],
  '1 to 2.5': choropleth_blue[2],
  '2.5 to 5': choropleth_blue[3],
  '5 to 7.5': choropleth_blue[4],
  '7.5 to 10': choropleth_blue[5],
  '10 to 12.5': choropleth_blue[6],
  '12.5 to 15': choropleth_blue[7],
  '15 to 17.5': choropleth_blue[8],
  '17.5 to 20': choropleth_blue[9],
  '20 to 30': choropleth_blue[10],
  '30 to 40': choropleth_blue[11],
  '40 to 50': choropleth_blue[12],
  '50 to 60': choropleth_blue[13],
  '60 to 70': choropleth_blue[14],
  '>=70': choropleth_blue[15]
};

const occupational_absolute_short_colors = colorMapToArray({
  '<10': choropleth_blue[3],
  '10 to 30': choropleth_blue[7],
  '30 to 50': choropleth_blue[11],
  '50 to 70': choropleth_blue[13],
  '>=70': choropleth_blue[15]
});

function colorMapToArray(colorMap){
  return Object.keys(colorMap).map(c => [c,colorMap[c]])
}

const matrixColors = [
  "#ddd",
  choropleth_blue[0],
  choropleth_blue[3],
  choropleth_blue[7],
  choropleth_blue[11]
];

const occupational_tertiary_education = {
  '≥90': choropleth_blue[11],
  '60 to 90': choropleth_blue[6],
  '30 to 60': choropleth_blue[3],
  '≤30': choropleth_blue[0]
};

const laborDemandSupply = {
  'Job lost': "#051C2C",
  'Jobs gained': "#00A9F4",
  'Net change': "#1F40E6",
  'Expected change in working age gap': "#A9E5EF"
};



module.exports = {
  CLUSTERS_COLORS_MAP: clusters_colors,
  CLUSTERS_COLORS_ARRAY: colorMapToArray(clusters_colors),
  EMPLOYMENT_RATE_COLORS_MAP: employment_rate_colors,
  EMPLOYMENT_RATE_COLORS_ARRAY: colorMapToArray(employment_rate_colors),
  JOB_GROWTH_COLORS_MAP: job_growth_colors,
  JOB_GROWTH_COLORS_ARRAY: colorMapToArray(job_growth_colors),
  OCCUPATIONAL_CHANGE_COLORS_MAP: occupational_change_colors,
  OCCUPATIONAL_CHANGE_COLORS_ARRAY: colorMapToArray(occupational_change_colors),
  OCCUPATIONAL_RELATIVE_COLORS_MAP: occupational_relative_colors,
  OCCUPATIONAL_RELATIVE_COLORS_ARRAY: colorMapToArray(occupational_relative_colors),
  OCCUPATIONAL_ABSOLUTE_COLORS_MAP: occupational_absolute_colors,
  OCCUPATIONAL_ABSOLUTE_COLORS_ARRAY: colorMapToArray(occupational_absolute_colors),
  MATRIX_COLORS: matrixColors,

  OCCUPATIONAL_CHANGE_COLORS_SHORT_ARRAY: occupational_change_short_colors,
  EMPLOYMENT_RATE_COLORS_SHORT_ARRAY: employment_rate_short_colors,
  OCCUPATIONAL_ABSOLUTE_COLORS_SHORT_ARRAY: occupational_absolute_short_colors,
  JOB_GROWTH_COLORS_SHORT_ARRAY: job_growth_short_colors,
  OCCUPATIONAL_RELATIVE_COLORS_SHORT_ARRAY: occupational_relative_short_colors,

  TERTIARY_EDUCATION_MAP: occupational_tertiary_education,
  TERTIARY_EDUCATION_ARRAY: colorMapToArray(occupational_tertiary_education),
  LABOR_DEMAND_SUPPLY_ARRAY: colorMapToArray(laborDemandSupply)
}
